import { flow } from 'fp-ts/function';
import { isString, toNumber } from 'lodash/fp';

function checkString(string: string, name: string) {
    if (!isString(string)) {
        throw new TypeError(`Expected ${name} to be string, got: (${String(string)}).`);
    }
}

export const parsePaymentCardExpirationDate = (expirationString: string) => {
    checkString(expirationString, 'expirationString');

    const [monthString, yearString = ''] = expirationString.replace(/[^0-9/]/g, '').split('/');
    const yearNumber = parseInt(yearString, 10);

    return {
        year: yearNumber + (yearNumber < 100 ? 2000 : 0),
        month: parseInt(monthString, 10),
    };
};

const parsePaymentCardDateYear = (expiration: string) => expiration.slice(0, 4);
const parsePaymentCardDateMonth = (expiration: string) => expiration.slice(5, 7);

// add space after 4th digit or * -> **** **** **** 1111
export const formatPaymentCardNumber = (number: string | undefined) => number?.match(/((\d|\*){4})/g)?.join(' ');

export const formatPaymentCardExpiry = (expiration: string) => {
    const expirationYear = parsePaymentCardDateYear(expiration);
    const expirationMonth = parsePaymentCardDateMonth(expiration);

    return `${expirationMonth} / ${expirationYear}`;
};

export const isPaymentCardExpired = (expiration: string, today: string) => {
    const currentYear = flow(parsePaymentCardDateYear, toNumber)(today);
    const currentMonth = flow(parsePaymentCardDateMonth, toNumber)(today);

    const expirationYear = flow(parsePaymentCardDateYear, toNumber)(expiration);
    const expirationMonth = flow(parsePaymentCardDateMonth, toNumber)(expiration);

    if (expirationYear < currentYear) {
        return true;
    }

    if (expirationMonth < currentMonth && expirationYear === currentYear) {
        return true;
    }

    return false;
};
